import React from "react";
import { Stack, Typography } from "@mui/material";
import type { EvaluationDomain } from "../../../../../../types/resolver";
import { WhenBuilder } from "../WhenBuilder";
import type { RuleComponentProps } from "./types";

/** Over collection is determined by the node's evaluation domain (evaluates), not user choice. */
function evaluationDomainToOver(domain: EvaluationDomain | undefined): string {
    if (domain === "CASE") return "caseAttributes";
    if (domain === "SPANS" || domain === "LOOSE_SPANS") return "looseSpans";
    return "codes";
}

const DEFAULT_WHEN_TRUE = { true: true as const };

export type QuantifierKind = "anyMatch" | "noneMatch";

export interface RuleQuantifierProps extends RuleComponentProps {
    kind: QuantifierKind;
}

export const RuleQuantifier: React.FC<RuleQuantifierProps> = ({
    value,
    onChange,
    kind,
    depth,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => {
    const quant = value?.[kind];
    const over = evaluationDomainToOver(evaluationDomain);
    const when = quant?.when ?? DEFAULT_WHEN_TRUE;

    const updateWhen = (w: import("../../../../../../types/resolver").WhenDto | null) => {
        if (w) onChange({ [kind]: { over, when: w } });
    };

    return (
        <Stack spacing={1}>
            <Typography variant="caption">Over: {over} (from node context)</Typography>
            <Typography variant="caption">Condition (per element)</Typography>
            <WhenBuilder
                value={when}
                onChange={updateWhen}
                depth={depth + 1}
                evaluationDomain={evaluationDomain}
                declaredDerivedAttributeNames={declaredDerivedAttributeNames}
            />
        </Stack>
    );
};
